// extracted by mini-css-extract-plugin
export default {"LocalNavigation":"LocalNavigation-module__LocalNavigation--PimyI"};